export default {
  background: '#e4001b',
};
